import createHttp from 'utils/http';

export const fetchOwnOrganizationTimezone = async () => {
    const http = createHttp();
    const query = `
                    query getUser {
                        ownUser {
                            org {
                                default_timezone
                            }
                        }
                    }
            `;

    const data = await http.graphql(query, {});

    return data.ownUser.org.default_timezone;
};
